module.exports = __webpack_public_path__ + "static/media/email.659256c9.png";